export default __webpack_public_path__ + "static/media/aqi_band_5.df8cf115.svg";